import { TranslationService } from '../services/translation.service';
import { type ILocationAutocompleteSelection } from '../components/Shared/LocationAutocomplete';
import { LocationAutocompleteSelectionType } from '../components/Shared/LocationAutocomplete/location-autocomplete-selection-type.enum';

interface LocationParameters {
  gid: string | undefined;
  name: string | undefined;
  latitude: number | undefined;
  longitude: number | undefined;
}

export class JourneySearchHelper {
  public static getLocationParameters(locationSelection: ILocationAutocompleteSelection): LocationParameters {
    const isLocationType = locationSelection.type === LocationAutocompleteSelectionType.location;

    return {
      gid: isLocationType ? locationSelection.location?.gid : undefined,
      name: isLocationType ? locationSelection.location?.name : TranslationService.get('common.autocomplete.currentposition'),
      latitude: isLocationType ? locationSelection.location?.latitude : locationSelection.coordinates?.latitude,
      longitude: isLocationType ? locationSelection.location?.longitude : locationSelection.coordinates?.longitude,
    };
  }
}
